export const placeHolder = {
	en: "Search by name",
	ko: "이름으로 검색",
	zh: "按姓名搜索",
};